export default __webpack_public_path__ + "static/media/banner-page-sncc.6308daa8.png";